// angular import
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// project import
import { AdminComponent } from './demo/layout/admin';
import { EmptyComponent } from './demo/layout/empty/empty.component';
import { AuthGuard } from './@theme/helpers/auth.guard';

const routes: Routes = [
  // Auth callback (handles SSO return)
  {
    path: 'auth-callback',
    component: EmptyComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./tabms/components/admin/tab-systems/tab-systems.component').then((c) => c.TabSystemsComponent)
      }
    ]
  },
  // Public routes (reports only, no auth guard)
  {
    path: 'reports/:props',
    component: EmptyComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('./tabms/components/base/base-report/base-report.component').then((c) => c.BaseReportComponent)
      }
    ]
  },
  {
    path: 'report-design/:props',
    component: EmptyComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('./tabms/components/base/report-designer/report-designer.component').then((c) => c.ReportDesignerComponent)
      }
    ]
  },
  // Main application routes (admin layout with auth guard)
  {
    path: '',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'secretary/dashboard',
        pathMatch: 'full'
      },
      {
        path: 'secretary',
        loadChildren: () => import('./tabms/pages/secretary/secretary.module').then((m) => m.SecretaryModule)
      },
      {
        path: 'contacts',
        loadChildren: () => import('./tabms/pages/contacts/contacts.module').then((m) => m.ContactsModule)
      },
      {
        path: 'account-settings',
        loadComponent: () => import('./tabms/pages/account-settings/account-settings.component').then((c) => c.MyAccountComponent)
      }
    ]
  },
  // Wildcard - redirect to secretary
  {
    path: '**',
    redirectTo: 'secretary/dashboard'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
